module.exports = __webpack_public_path__ + "static/media/2002.79978e04.png";